import React, { useEffect, useState } from "react";
import {
  Button,
  Tooltip,
  Table,
  Form,
  message
} from "antd";

import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { GestionPaieService } from "../Services/GestionPaieService";
import SalariesModal from "./Modal_Doc/SalariesModal";

const Salaries = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [convention, setConvention] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [form] = Form.useForm();
  const gestionPaieService = new GestionPaieService();
  const [refreshKey, setRefreshKey] = useState(0);
  const [pageSize, setPageSize] = useState(10)
  const userProfil = localStorage.getItem("profil"); // Récupère le profil de l'utilisateur
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const salaries = await gestionPaieService.getAllSalaries();
        setTableData(salaries);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [refreshKey]); // Dépendance ici

  

  const showModal = async (employee) => {
    setCurrentEmployee(employee); // Assigner tout l'objet record ici
    setIsModalVisible(true);
    // Récupération des données supplémentaires si nécessaire
    try {
      const [categResponse, conventionResponse] = await Promise.all([
        gestionPaieService.getCateg(),
        gestionPaieService.getConvention(),
      ]);
      setCategories(categResponse);
      setConvention(conventionResponse);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      message.error("Erreur lors de la récupération des données.");
    }
  };
  

  const handleSaveSuccess = () => {
    setRefreshKey(oldKey => oldKey + 1);
    handleModalClose();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setCurrentEmployee(null);
    form.resetFields();
  };

 
  const columns = [
    {
      title: "Matricule",
      dataIndex: "matricule",
      key: "matricule",
      align: "center",
      sorter: (a, b) => a.matricule.localeCompare(b.matricule),
    },
    {
      title: "Civilité",
      dataIndex: "civilite",
      key: "civilite",
      sorter: (a, b) => a.civilite.localeCompare(b.civilite),
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
      title: "Prénom(s)",
      dataIndex: "prenoms",
      key: "prenoms",
      sorter: (a, b) => a.prenoms.localeCompare(b.prenoms),
    },
    {
      title: "Emploi",
      dataIndex: "emploi",
      key: "emploi",
      sorter: (a, b) => a.emploi.localeCompare(b.emploi),
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
      ? [
          {
            title: (
              <div
                style={{
                  backgroundColor: "#010f1c",
                  color: "white",
                  padding: "1px",
                }}
              ></div>
            ),
            dataIndex: "actions",
            key: "actions",
            align: "center",
            fixed: "right",
            render: (text, record) => (
              <span>
                <Tooltip title="Modifier">
                  <EditOutlined
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => showModal(record)}
                  />
                </Tooltip>
              </span>
            ),
          },
        ]
      : []),
  ];
  
  return (
    <div>
      {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
        <div style={{ textAlign: "right", marginBottom: 16 }}>
          <Button className="buttonExport" onClick={() => showModal(null)}>
            <PlusOutlined />
            Nouveau Salarié
          </Button>
        </div>
      )}
      <Table
        columns={columns}
        dataSource={tableData}
        scroll={{
          x: true,
        }}
        showSorterTooltip={false}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
      <SalariesModal
        isVisible={isModalVisible}
        onClose={handleModalClose}
        onSuccess={handleSaveSuccess}
        employee={currentEmployee}
        categories={categories}
        convention={convention}
      />
    </div>
  );
};

export default Salaries;
